
        import '/home/builduser/work/5d4c7c61b0622e62/santa-editor/packages/appManager/AppManagerPanel/AppManagerPanel.scss.css.virtualfile';
        module.exports = {"content":"_content_1bpb0_7","loaderWrapper":"_loaderWrapper_1bpb0_12"};